<template>
  <div v-if="youtubeId" class="video-youtube">
    <iframe
      v-if="inited"
      :src="embedLink"
      class="video-youtube__iframe"
      allowfullscreen
      allow="autoplay"
      frameborder="0"
      @load="handleLoad"
    />
    <div v-else class="video-youtube__iframe" @click.stop="handleClick">
      <img :src="coverLink" class="video-youtube__img" alt="video cover" />
      <PlayIcon class="video-youtube__icon" />
    </div>
    <DualRingLoader :visible="!loaded && inited" class="video-youtube__loader" />
  </div>
</template>

<script>
import PlayIcon from './images/play.vue.svg';
import DualRingLoader from '~/components/common/DualRingLoader';
import { YOUTUBE_REGEXP } from '~/components/utils/validate/rules';
import warRoomSignUpMixin from '~/components/partials/war-room/WarRoomSignUp/warRoomSignUpMixin';

export default {
  name: 'VideoYoutube',
  components: {
    PlayIcon,
    DualRingLoader,
  },
  mixins: [warRoomSignUpMixin],
  props: {
    youtubeLink: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      inited: false,
      loaded: false,
    };
  },
  computed: {
    youtubeId() {
      const found = this.youtubeLink.match(YOUTUBE_REGEXP);
      if (!found || found.length < 2) return null;
      return found[1];
    },
    coverLink() {
      return `//i3.ytimg.com/vi/${this.youtubeId}/hqdefault.jpg`;
    },
    embedLink() {
      return `//www.youtube.com/embed/${this.youtubeId}?rel=0&showinfo=0&autoplay=1&enablejsapi=1`;
    },
  },
  methods: {
    handleClick() {
      this.inited = true;
    },
    handleLoad() {
      this.loaded = true;
    },
  },
};
</script>

<style scoped lang="scss">
.video-youtube {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
  cursor: pointer;
  background-color: var(--theme-color-background);

  &__iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    padding: 0;
    transform: translate(-50%, -50%);
  }

  &__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    padding: 0;
    width: 68px;
    height: 48px;
    border: none;
    background-color: transparent;
    transform: translate(-50%, -50%);
    cursor: pointer;

    ::v-deep .video__button-shape {
      fill: var(--gray-80);
      fill-opacity: 0.8;
    }

    ::v-deep .video__button-icon {
      fill: #fff;
    }

    &:focus {
      outline: none;
    }
  }

  &:hover ::v-deep .video__button-shape,
  &__button:focus ::v-deep .video__button-shape {
    fill: var(--red-50);
    fill-opacity: 1;
  }
}
</style>
